module.exports = __webpack_public_path__ + "media/about/PhotosPreview-ab950492.jpg";